export var valuesTreeLayout = ["orthogonal", "radial"];
//# sourceMappingURL=TreeLayout.js.map